import { NavigateFunction } from 'react-router-dom';

/**
 * Unified navigation system for reading books
 * Can navigate to a specific page or let the reader handle resumption
 * Passes returnPath in state so back button knows where to go
 */
export const navigateToBook = (
  bookId: number, 
  navigate: NavigateFunction,
  options: { forceFromStart?: boolean; currentPage?: number; returnPath?: string } = {}
) => {
  const { forceFromStart = false, currentPage, returnPath } = options;
  
  // Use provided returnPath or current location as fallback
  const state = { returnPath: returnPath || window.location.pathname };
  
  // If we have a specific page to navigate to and not forcing from start
  if (currentPage && currentPage > 0 && !forceFromStart) {
    navigate(`/read/${bookId}?page=${currentPage}`, { state });
  } else {
    // Simple navigation - let the reader handle loading from database
    navigate(`/read/${bookId}`, { state });
  }
};

/**
 * Hook for consistent book navigation
 */
export const useBookNavigation = () => {
  return {
    navigateToBook
  };
};